import { render, staticRenderFns } from "./DeleteAssetButton.vue?vue&type=template&id=16f6908d&"
import script from "./DeleteAssetButton.vue?vue&type=script&lang=js&"
export * from "./DeleteAssetButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f6908d')) {
      api.createRecord('16f6908d', component.options)
    } else {
      api.reload('16f6908d', component.options)
    }
    module.hot.accept("./DeleteAssetButton.vue?vue&type=template&id=16f6908d&", function () {
      api.rerender('16f6908d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AssetTracking/Buttons/DeleteAssetButton.vue"
export default component.exports